class ProductVariantPreview extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.initializeProperties()
    this.addEventListeners()
  }

  initializeProperties() {
    this.changeVariantBtns = Array.from(this.querySelectorAll('.change-variant-btn'))
    this.cardMedia = this.querySelector('.card__inner .card__media .media')
    this.variantMedia = this.querySelector('.card__inner .card__media .variant-preview-media')
    this.variantImages = this.variantMedia.querySelectorAll('img')
    this.cardQuickAddForm = this.querySelector('.quick-add product-form form')
    this.cardFormInputId = this.cardQuickAddForm.querySelector('input[name="id"]')
    this.quickAddModalButton = this.querySelector('.quick-add .card__quick-add-modal-button')
    this.quickAddFormSubmitButton = this.querySelector('.quick-add .card__quick-add-form-button')
    this.quickAddSoldOutButton = this.querySelector('.quick-add .card__quick-add-sold-out-button')
  }

  addEventListeners() {
    this.changeVariantBtns.forEach((button) => {
      button.addEventListener('click', this.changeVariantImagePreview.bind(this))
    })
  }

  changeVariantImagePreview(event) {
    const variantPreviewId = event.currentTarget.dataset.variantPreview
    const productVariantId = event.currentTarget.dataset.productVariantId
    const variantAvailable = event.currentTarget.dataset.variantAvailable === 'true'

    this.cardFormInputId.value = productVariantId

    this.variantImages.forEach((img) => img.classList.remove('active'))

    const selectedVariantImage = this.variantMedia.querySelector(`#${variantPreviewId}`)
    this.cardMedia.style.opacity = selectedVariantImage ? '0' : '1'
    selectedVariantImage?.classList.add('active')

    this.changeVariantBtns.forEach((btn) => btn.classList.remove('active'))
    event.currentTarget.classList.add('active')

    this.quickAddModalButton.classList.remove('button-active')
    this.quickAddFormSubmitButton.classList.toggle('button-active', variantAvailable)
    this.quickAddSoldOutButton.classList.toggle('button-active', !variantAvailable)
  }
}

customElements.define('variant-preview', ProductVariantPreview)
